import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-549c66e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "type" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "type1" }, "发票类型", -1))
const _hoisted_3 = {
  key: 0,
  class: "p1"
}
const _hoisted_4 = {
  key: 1,
  class: "p1"
}
const _hoisted_5 = {
  key: 2,
  class: "type2"
}
const _hoisted_6 = {
  key: 3,
  class: "p2"
}
const _hoisted_7 = {
  key: 4,
  class: "p2"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("p", null, "开票信息")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "name"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "个人名称", -1))
const _hoisted_11 = {
  key: 1,
  class: "name"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "单位名称", -1))
const _hoisted_13 = {
  key: 2,
  class: "name"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "单位税号", -1))
const _hoisted_15 = {
  key: 3,
  class: "name"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "单位地址", -1))
const _hoisted_17 = {
  key: 4,
  class: "name"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "单位电话", -1))
const _hoisted_19 = {
  key: 5,
  class: "name"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "开户银行", -1))
const _hoisted_21 = {
  key: 6,
  class: "name"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "银行账号", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "names" }, [
  /*#__PURE__*/_createElementVNode("p", null, "发票内容"),
  /*#__PURE__*/_createElementVNode("div", null, "信息服务费")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("p", null, "收票信息")
], -1))
const _hoisted_25 = { class: "address" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, "收票地址", -1))
const _hoisted_27 = { class: "right" }
const _hoisted_28 = { class: "top" }
const _hoisted_29 = { class: "user" }
const _hoisted_30 = { class: "phone" }
const _hoisted_31 = { class: "footer" }
const _hoisted_32 = { class: "footed" }
const _hoisted_33 = {
  key: 7,
  class: "button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (!_ctx.userinfor.data.bank_nu)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "普通发票"))
        : _createCommentVNode("", true),
      (_ctx.userinfor.data.bank_nu)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "增值税专用发票"))
        : _createCommentVNode("", true),
      (!_ctx.userinfor.data.bank_nu)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "抬头类型"))
        : _createCommentVNode("", true),
      (_ctx.selfForm.name != '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "个人"))
        : _createCommentVNode("", true),
      (_ctx.firmForm.name)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, "单位"))
        : _createCommentVNode("", true)
    ]),
    _hoisted_8,
    (_ctx.radio2 == 1 && _ctx.userinfor.data.people)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", null, _toDisplayString(_ctx.userinfor.data.people), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.userinfor.data.company)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", null, _toDisplayString(_ctx.userinfor.data.company), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.userinfor.data.duty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", null, _toDisplayString(_ctx.userinfor.data.duty), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.userinfor.data.com_address)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", null, _toDisplayString(_ctx.userinfor.data.com_address), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.userinfor.data.com_mobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", null, _toDisplayString(_ctx.userinfor.data.com_mobile), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.userinfor.data.bank)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", null, _toDisplayString(_ctx.userinfor.data.bank), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.userinfor.data.bank_nu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", null, _toDisplayString(_ctx.userinfor.data.bank_nu), 1)
        ]))
      : _createCommentVNode("", true),
    _hoisted_23,
    _hoisted_24,
    _createElementVNode("div", _hoisted_25, [
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.userinfor.data.name), 1),
          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.userinfor.data.phone), 1)
        ]),
        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.userinfor.data.province), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_32, " 2个工作日内以快递(顺丰快递)的方式邮寄出,配送到您所预留的收票地址,请注意查收!" + _toDisplayString(_ctx.isEdit), 1),
    (_ctx.isEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("button", {
            class: "button1",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, "修改"),
          _createElementVNode("button", {
            class: "button2",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          }, "提交")
        ]))
      : _createCommentVNode("", true)
  ], 64))
}